'use strict'

export default (mockAxios) => {
  // 一覧
  mockAxios.onGet(`/personal-settings/tags`).reply(200, {
    'success': true,
    'data': [
      {
        'id': 1,
        'name': 'サンプルタグ',
        'color': '000000lo',
        'color_rgb': '#ffecb3',
        'count_persons': 12345,
        'formatted_count_persons': '12,345',
        'openflag': '1' }
    ],
    'pagination': {
      'page_count': 5,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 55,
      'limit': 10
    }
  })

  // 個人タグ情報取得
  mockAxios.onGet(new RegExp(`/personal-settings/tags/\\d+`)).reply(200, {
    'success': true,
    'data': {
      'id': 1,
      'name': 'サンプルタグ',
      'color': '000000lo',
      'color_rgb': '#ffecb3',
      'memo': 'サンプルメモ',
      'openflag': '1'
    }
  })

  // 個人タグ作成
  mockAxios.onPost(`/personal-settings/tags`).reply(201, {
    'success': true,
    'data': {
      'id': 1,
      'name': 'サンプルタグ',
      'color': '000000lo',
      'color_rgb': '#ffecb3',
      'openflag': '1'
    }
  })

  // 個人タグ更新
  mockAxios.onPut(new RegExp(`/personal-settings/tags/\\d+`)).reply(200, {
    'success': true,
    'data': []
  })

  // 削除
  mockAxios.onDelete(new RegExp(`/personal-settings/tags/\\d+`)).reply(200, {
    'success': true,
    'data': []
  })

  // 一括削除
  mockAxios.onPost(`/personal-settings/tags/delete`).reply(200, {
    'success': true,
    'data': []
  })

  // 表示順移動
  mockAxios.onPut(`/personal-settings/tags/sort`).reply(200, {
    'success': true,
    'data': []
  })

  // 色候補取得
  mockAxios.onGet(`/personal-settings/tags/colors`).reply(200, {
    'success': true,
    'data': {
      'tag_colors': [
        {
          'id': '000000dr',
          'rgb': '#e91e63'
        },
        {
          'id': '000000do',
          'rgb': '#ffc107'
        },
        {
          'id': '000000dg',
          'rgb': '#4caf50'
        },
        {
          'id': '000000db',
          'rgb': '#03a9f4'
        },
        {
          'id': '000000dp',
          'rgb': '#673ab7'
        },
        {
          'id': '000000dh',
          'rgb': '#9e9e9e'
        },
        {
          'id': '000000lr',
          'rgb': '#f8bbd0'
        },
        {
          'id': '000000lo',
          'rgb': '#ffecb3'
        },
        {
          'id': '000000lg',
          'rgb': '#c8e6c9'
        },
        {
          'id': '000000lb',
          'rgb': '#b3e5fc'
        },
        {
          'id': '000000lp',
          'rgb': '#d1c4e9'
        },
        {
          'id': '000000lh',
          'rgb': '#e0e0e0'
        }
      ]
    }
  })

  // ダイアログ用個人タグ一覧取得
  mockAxios.onGet(`/personal-settings/tags/seltags`).reply(200, {
    'success': true,
    'data': [
      {
        'id': 1,
        'name': 'サンプルタグ',
        'color': '000000lo',
        'color_rgb': '#ffecb3',
        'formatted_count_persons': '12,345',
        'openflag': '1'
      }
    ],
    'pagination': {
      'page_count': 5,
      'current_page': 1,
      'has_next_page': true,
      'has_prev_page': false,
      'count': 55,
      'limit': 10
    }
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/pvtagRepositoryMock.js